import React from "react";
import withAuthorization from "../components/Session/withAuthorization";
import UsersList from "../components/DBItemsList";

class UsersPage extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { isLoading, loadError, usersData } = this.props;

    return (
      <div>
        <h1>Users</h1>
        {loadError ? (
          "Error loading"
        ) : isLoading || !usersData ? (
          "Loading..."
        ) : (
          <UsersList items={usersData} />
        )}
      </div>
    );
  }
}

const authCondition = (authUser) => !!authUser;

export default withAuthorization(authCondition)(UsersPage);
